// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcoRecommendationsDataInner } from './EcoRecommendationsDataInner';
import {
    EcoRecommendationsDataInnerFromJSON,
    EcoRecommendationsDataInnerFromJSONTyped,
    EcoRecommendationsDataInnerToJSON,
    EcoRecommendationsDataInnerToJSONTyped,
} from './EcoRecommendationsDataInner';

/**
 * 
 * @export
 * @interface EcoRecommendations
 */
export interface EcoRecommendations {
    /**
     * 
     */
    data?: Array<EcoRecommendationsDataInner>;
}

/**
 * Check if a given object implements the EcoRecommendations interface.
 */
export function instanceOfEcoRecommendations(value: object): value is EcoRecommendations {
    return true;
}

export function EcoRecommendationsFromJSON(json: any): EcoRecommendations {
    return EcoRecommendationsFromJSONTyped(json, false);
}

export function EcoRecommendationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcoRecommendations {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EcoRecommendationsDataInnerFromJSON)),
    };
}

export function EcoRecommendationsToJSON(json: any): EcoRecommendations {
    return EcoRecommendationsToJSONTyped(json, false);
}

export function EcoRecommendationsToJSONTyped(value?: EcoRecommendations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EcoRecommendationsDataInnerToJSON)),
    };
}

